import { ReviewSummaryT } from '@/settings/types';

export const FALLBACK_REVIEWS_SUMMARY: ReviewSummaryT = {
  count: 0,
  stars: 4.5,
  countAbove3andAHalf: 0,
  starPercentages: {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
  },
};

export const MIN_SUMMARY_STARS_FOR_DISPLAY = 4.5;
